import { UiNavImagesModel } from "../../models";

import { mockRouteModel } from "./mock-route";

export function mockUiNavImagesModel({
    id = "nav-images-1234",
    type = "uiNavImages",
    locale = "en",
    content = mockUiNavImagesModelContent()
}: Partial<UiNavImagesModel> = {}): UiNavImagesModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiNavImagesModelContent = UiNavImagesModel["content"];

export function mockUiNavImagesModelContent({
    title = "This is a title",
    pages = ["1", "2", "3"].map((id) => mockRouteModel({ id })),
    ...optionals
}: Partial<UiNavImagesModelContent> = {}): UiNavImagesModelContent {
    return {
        title,
        pages,
        ...optionals
    };
}
